/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

// Terms & Conditions checkbox at the cart
 
$(document).ready(function () {
  $("body").on("click",'[name="checkout"]',function () {
    if ($("#ACCEPT").is(":checked")) {
      fbq('track', 'InitiateCheckout');
      pageTracker._trackEvent("ecommerce", "begin_checkout", "InitiateCheckout" );
    } else {
      $(".ast-spinner").remove();
      return false;
    }
  });
  $(document).on('submit','form#contact_form',function(){
    fbq('track', 'Lead');
  });  
  $('.addcustom-btn').on('click', function(e) {
    var form = $('form[action*="/cart/add"]');
    e.preventDefault()
    $.ajax({
      type: 'POST',                             
      url: '/cart/add.js',
      dataType: 'json',                               
      data: form.serialize(),
      success: function(data) {
        window.location.href = "".concat(window.location.origin, "/cart");
      }
    });
  });  
  
});
/*
var $text = $("#customjs").data("msgproductrel");
const observer = new MutationObserver(function(mutations_list) {
	mutations_list.forEach(function(mutation) {
		mutation.addedNodes.forEach(function(added_node) {
          if( added_node.dataset ){
          	if( added_node.dataset.id  ) {
              //$("div[data-id='"+added_node.dataset.id+"'] h3").html('');
              console.log( { id: added_node.dataset.id , text: $text} );
        	  $("div[data-id='"+added_node.dataset.id+"'] h3").html($text);
			}
          }
		});
	});
});
observer.observe(document.getElementById("main"), { subtree: true, childList: true });
*/
document.addEventListener('variant:changed', function(event) {
    var variant = event.detail.variant; // Gives you access to the whole variant details
    if(variant.available){
      $('.ProductForm__AddToCart').css('pointer-events','all');
      $('.ProductForm__AddToCart').css('opacity','1');
    }
  else{
    $('.ProductForm__AddToCart').css('opacity','0.3');
    $('.ProductForm__AddToCart').css('pointer-events','none');
  }
});